module.exports = __webpack_public_path__ + "static/media/video.c6ee34ff.mp4";